export const create = {
  createSuccessfully: 'Create new operator successfully!',
}
